export default (state, action) => ({
  ...state,
  parent: {
    ...state.parent,
    content: {
      ...state.parent.content,
      title: action.payload
    }
  }
})
